import { render, staticRenderFns } from "./DocRankList.vue?vue&type=template&id=17539bdc&scoped=true"
import script from "./DocRankList.vue?vue&type=script&lang=js"
export * from "./DocRankList.vue?vue&type=script&lang=js"
import style0 from "./DocRankList.vue?vue&type=style&index=0&id=17539bdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17539bdc",
  null
  
)

export default component.exports